<script>
  /*
		Using material icons: https://fonts.google.com/icons
		Use the string name of the icon, e.g. 'add' or 'add_circle_outline'
		Uses lowercase and replace spaces with underscores
	*/
  import AddUserIcon from '$lib/assets/icons/add-user.svg?component';
  import ArrowBackIcon from '$lib/assets/icons/arrow-back.svg?component';
  import ArrowDownAdjIcon from '$lib/assets/icons/arrow-down-adj.svg?component';
  import ArrowDownIcon from '$lib/assets/icons/arrow-down.svg?component';
  import ArrowExpandIcon from '$lib/assets/icons/arrow-expand.svg?component';
  import ArrowForwardIcon from '$lib/assets/icons/arrow-forward.svg?component';
  import ArrowMinimizeIcon from '$lib/assets/icons/arrow-minimize.svg?component';
  import ArrowRefreshIcon from '$lib/assets/icons/arrow-refresh.svg?component';
  import ArrowResetIcon from '$lib/assets/icons/arrow-reset.svg?component';
  import ArrowRightIcon from '$lib/assets/icons/arrow-right.svg?component';
  import ArrowUpAdjIcon from '$lib/assets/icons/arrow-up-adj.svg?component';
  import ArrowUpIcon from '$lib/assets/icons/arrow-up.svg?component';
  import ArticleIcon from '$lib/assets/icons/article.svg?component';
  import BankidIcon from '$lib/assets/icons/bankid.svg?component';
  import BenchmarkIcon from '$lib/assets/icons/benchmark.svg?component';
  import BookingIcon from '$lib/assets/icons/booking.svg?component';
  import CalendarIcon from '$lib/assets/icons/calendar.svg?component';
  import CaregiverIcon from '$lib/assets/icons/caregiver.svg?component';
  import ChatIcon from '$lib/assets/icons/chat.svg?component';
  import CheckIcon from '$lib/assets/icons/check.svg?component';
  import CheckBoxOffIcon from '$lib/assets/icons/checkbox-off.svg?component';
  import CheckBoxOnIcon from '$lib/assets/icons/checkbox-on.svg?component';
  import CheckedOffIcon from '$lib/assets/icons/checked-off.svg?component';
  import CheckedOnIcon from '$lib/assets/icons/checked-on.svg?component';
  import ChevronDownIcon from '$lib/assets/icons/chevron-down.svg?component';
  import ChevronLeftIcon from '$lib/assets/icons/chevron-left.svg?component';
  import ChevronRightIcon from '$lib/assets/icons/chevron-right.svg?component';
  import ChevronUpIcon from '$lib/assets/icons/chevron-up.svg?component';
  import ClockIcon from '$lib/assets/icons/clock.svg?component';
  import CloseIcon from '$lib/assets/icons/close.svg?component';
  import CollectionIcon from '$lib/assets/icons/collection.svg?component';
  import CommentsIcon from '$lib/assets/icons/comments.svg?component';
  import CompanyMessageIcon from '$lib/assets/icons/company-message.svg?component';
  import CompanyIcon from '$lib/assets/icons/company.svg?component';
  import CompareIcon from '$lib/assets/icons/compare.svg?component';
  import Copy from '$lib/assets/icons/copy.svg?component';
  import DeleteIcon from '$lib/assets/icons/delete.svg?component';
  import DownloadIcon from '$lib/assets/icons/download.svg?component';
  import DragDotsIcon from '$lib/assets/icons/drag-dots.svg?component';
  import EditIcon from '$lib/assets/icons/edit.svg?component';
  import EnvelopeIcon from '$lib/assets/icons/envelope.svg?component';
  import ErrorIcon from '$lib/assets/icons/error.svg?component';
  import FavoriteIcon from '$lib/assets/icons/favorite.svg?component';
  import FileIcon from '$lib/assets/icons/file.svg?component';
  import FilterIcon from '$lib/assets/icons/filter.svg?component';
  import FoodIcon from '$lib/assets/icons/food.svg?component';
  import GlobeIcon from '$lib/assets/icons/globe.svg?component';
  import GroupIcon from '$lib/assets/icons/group.svg?component';
  import HeartmonitorIcon from '$lib/assets/icons/heartmonitor.svg?component';
  import HemogoblinIcon from '$lib/assets/icons/hemogoblin.svg?component';
  import HomeIcon from '$lib/assets/icons/home.svg?component';
  import HospitalIcon from '$lib/assets/icons/hospital.svg?component';
  import HumanIcon from '$lib/assets/icons/human.svg?component';
  import InfoIcon from '$lib/assets/icons/info.svg?component';
  import LikeIcon from '$lib/assets/icons/like.svg?component';
  import LinkIcon from '$lib/assets/icons/link.svg?component';
  import LogIcon from '$lib/assets/icons/log.svg?component';
  import LogoIcon from '$lib/assets/icons/logo.svg?component';
  import LogoutIcon from '$lib/assets/icons/logout.svg?component';
  import MailIcon from '$lib/assets/icons/mail.svg?component';
  import MenuIcon from '$lib/assets/icons/menu.svg?component';
  import MessageIcon from '$lib/assets/icons/message.svg?component';
  import MinusIcon from '$lib/assets/icons/minus.svg?component';
  import NotificationBellOffIcon from '$lib/assets/icons/notification-bell-off.svg?component';
  import notificationBellIcon from '$lib/assets/icons/notification-bell.svg?component';
  import PauseIcon from '$lib/assets/icons/pause.svg?component';
  import PhoneIcon from '$lib/assets/icons/phone.svg?component';
  import PlayIcon from '$lib/assets/icons/play.svg?component';
  import PlusIcon from '$lib/assets/icons/plus.svg?component';
  import PodcastIcon from '$lib/assets/icons/podcast.svg?component';
  import RecycleIcon from '$lib/assets/icons/recycle.svg?component';
  import SaveIcon from '$lib/assets/icons/save.svg?component';
  import SearchIcon from '$lib/assets/icons/search.svg?component';
  import SelfhelpIcon from '$lib/assets/icons/selfhelp.svg?component';
  import SendIcon from '$lib/assets/icons/send.svg?component';
  import SettingsIcon from '$lib/assets/icons/settings.svg?component';
  import SortIcon from '$lib/assets/icons/sort.svg?component';
  import SoundIcon from '$lib/assets/icons/sound.svg?component';
  import StrikeThroughIcon from '$lib/assets/icons/strike-through.svg?component';
  import SyringeIcon from '$lib/assets/icons/syringe.svg?component';
  import UploadIcon from '$lib/assets/icons/upload.svg?component';
  import UserIcon from '$lib/assets/icons/user.svg?component';
  import VideoCallIcon from '$lib/assets/icons/video-call.svg?component';
  import WarningIcon from '$lib/assets/icons/warning.svg?component';
  import ZoomInIcon from '$lib/assets/icons/zoom-in.svg?component';
  import ZoomOutIcon from '$lib/assets/icons/zoom-out.svg?component';
  import { twMerge } from 'tailwind-merge';
  import Spinner from './Spinner.svelte';

  import SadSmileIcon from '$lib/assets/icons/sad-smile.svg?component';

  import HappySmileIcon from '$lib/assets/icons/happy-smile.svg?component';
  import OkSmileIcon from '$lib/assets/icons/ok-smile.svg?component';

  let {
    icon = '',
    loading = false,
    size = 'md',
    class: className = null,
  } = $props();

  const sizeClass = $derived(
    {
      xs: 'text-xs',
      sm: 'text-sm',
      md: 'text-base',
      lg: 'text-[16px]',
      xl: 'text-[24px]',
      '2xl': 'text-2xl',
    }[size],
  );

  const heightClass = $derived(
    {
      xs: { height: 11, width: 11 },
      sm: { height: 12, width: 12 },
      md: { height: 14, width: 14 },
      lg: { height: 16, width: 16 },
      xl: { height: 24, width: 24 },
      '2xl': { height: 48, width: 48 },
    }[size],
  );

  const classes = $derived(twMerge(['material-symbols-outlined', sizeClass]));

  const icons = {
    addUser: AddUserIcon,
    arrowBack: ArrowBackIcon,
    arrowDownAdj: ArrowDownAdjIcon,
    arrowDown: ArrowDownIcon,
    arrowExpand: ArrowExpandIcon,
    arrowForward: ArrowForwardIcon,
    arrowMinimize: ArrowMinimizeIcon,
    arrowRefresh: ArrowRefreshIcon,
    arrowReset: ArrowResetIcon,
    arrowRight: ArrowRightIcon,
    arrowUp: ArrowUpIcon,
    arrowUpAdj: ArrowUpAdjIcon,
    article: ArticleIcon,
    bankid: BankidIcon,
    notificationBell: notificationBellIcon,
    notificationBellOff: NotificationBellOffIcon,
    benchmark: BenchmarkIcon,
    booking: BookingIcon,
    calendar: CalendarIcon,
    caregiver: CaregiverIcon,
    chat: ChatIcon,
    check: CheckIcon,
    checkBoxOff: CheckBoxOffIcon,
    checkBoxOn: CheckBoxOnIcon,
    checkedOff: CheckedOffIcon,
    checkedOn: CheckedOnIcon,
    chevronDown: ChevronDownIcon,
    chevronLeft: ChevronLeftIcon,
    chevronRight: ChevronRightIcon,
    chevronUp: ChevronUpIcon,
    clock: ClockIcon,
    close: CloseIcon,
    collection: CollectionIcon,
    copy: Copy,
    comments: CommentsIcon,
    company: CompanyIcon,
    compare: CompareIcon,
    delete: DeleteIcon,
    download: DownloadIcon,
    dragDots: DragDotsIcon,
    edit: EditIcon,
    envelope: EnvelopeIcon,
    error: ErrorIcon,
    favorite: FavoriteIcon,
    file: FileIcon,
    filter: FilterIcon,
    food: FoodIcon,
    globe: GlobeIcon,
    group: GroupIcon,
    heartmonitor: HeartmonitorIcon,
    hemogoblin: HemogoblinIcon,
    home: HomeIcon,
    hospital: HospitalIcon,
    info: InfoIcon,
    logout: LogoutIcon,
    like: LikeIcon,
    link: LinkIcon,
    logo: LogoIcon,
    mail: MailIcon,
    menu: MenuIcon,
    message: MessageIcon,
    minus: MinusIcon,
    pause: PauseIcon,
    phone: PhoneIcon,
    play: PlayIcon,
    plus: PlusIcon,
    podcast: PodcastIcon,
    recycle: RecycleIcon,
    save: SaveIcon,
    search: SearchIcon,
    selfhelp: SelfhelpIcon,
    send: SendIcon,
    settings: SettingsIcon,
    sort: SortIcon,
    sound: SoundIcon,
    strikethrough: StrikeThroughIcon,
    syringe: SyringeIcon,
    upload: UploadIcon,
    user: UserIcon,
    videocall: VideoCallIcon,
    zoomin: ZoomInIcon,
    zoomout: ZoomOutIcon,
    sadsmiley: SadSmileIcon,
    oksmiley: OkSmileIcon,
    happysmiley: HappySmileIcon,
    warning: WarningIcon,
    companyMessage: CompanyMessageIcon,
    human: HumanIcon,
    log: LogIcon,
  };

  const exists = $derived(Object.keys(icons).includes(icon));
</script>

<span class="icon {classes}">
  {#if loading === true}
    <Spinner {size} />
  {:else if !exists}
    {icon?.toLowerCase().replace(/ /g, '_')}
  {:else if exists}
    {@const IconComponent = icons[icon]}
    <div class="inline-block">
      <IconComponent
        height={heightClass.height}
        width={heightClass.width}
        class={className}
      />
    </div>
  {/if}
</span>

<style>
  .icon :global(svg) {
    width: 100%;
    height: 100%;
  }
</style>
